import { getSubscription } from '../../../../../api';
import { SubscriptionAdapter } from '../../../../app/billing';
import { SubscriptionApiAdapterConfig } from './subscriptionApiConfig';

export function createSubscriptionApiImpl(
    config: SubscriptionApiAdapterConfig
): SubscriptionAdapter {
    return {
        async getSubscription(workspace) {
            const response = await getSubscription(config.axios);
            return response;
        },
    };
}
